import { Controller } from "@hotwired/stimulus"
import {
  ClassicEditor,
  Bold, Italic, Underline, Strikethrough,
  Essentials, Paragraph,
  List, Indent,
  FontColor, FontBackgroundColor, FontSize, FontFamily,
  Alignment,
  Heading,
  BlockQuote,
  Table, TableToolbar,
  HorizontalLine,
  Link,
  Undo
} from "ckeditor5"

export default class extends Controller {
  static values = { toolbar: { type: String, default: "full" }, stamp: { type: String, default: "" } }

  connect() {
    ClassicEditor.create(this.element, {
      licenseKey: "GPL",
      plugins: [
        Essentials, Paragraph,
        Bold, Italic, Underline, Strikethrough,
        FontColor, FontBackgroundColor, FontSize, FontFamily,
        Alignment,
        Heading,
        BlockQuote,
        Table, TableToolbar,
        HorizontalLine,
        List, Indent,
        Link,
        Undo
      ],
      table: { contentToolbar: [ "tableColumn", "tableRow", "mergeTableCells" ] },
      fontSize: {
        options: [ "8pt", "9pt", "10pt", "11pt", "12pt", "14pt", "16pt", "18pt", "20pt", "24pt", "28pt", "32pt", "36pt" ],
        supportAllValues: true
      },
      heading: {
        options: [
          { model: "paragraph", title: "Parágrafo", class: "ck-heading_paragraph" },
          { model: "heading1", view: "h1", title: "Título 1", class: "ck-heading_heading1" },
          { model: "heading2", view: "h2", title: "Título 2", class: "ck-heading_heading2" },
          { model: "heading3", view: "h3", title: "Título 3", class: "ck-heading_heading3" }
        ]
      },
      toolbar: this.toolbarConfig()
    }).then(editor => {
      this.editor = editor
      this._applyHeight(editor)
      this.form = this.element.closest("form")
      if (this.form) {
        this.submitHandler = () => { this.element.value = editor.getData() }
        this.form.addEventListener("submit", this.submitHandler)
      }
      if (this.stampValue) {
        const domRoot = editor.editing.view.getDomRoot()
        let stampPosition = null

        domRoot.addEventListener("mousedown", () => {
          setTimeout(() => {
            const sel = editor.model.document.selection
            if (sel.isCollapsed) stampPosition = sel.getFirstPosition()
          }, 0)
        })

        domRoot.addEventListener("dblclick", () => {
          editor.model.change(writer => {
            const position = stampPosition || editor.model.document.selection.getFirstPosition()
            writer.setSelection(position)
            editor.model.insertContent(writer.createText(this.stampValue))
            stampPosition = null
          })
        })
      }
    }).catch(err => {
      console.error("[CKEditor] error:", err)
    })
  }

  disconnect() {
    if (this.form && this.submitHandler) {
      this.form.removeEventListener("submit", this.submitHandler)
    }
    this.editor?.destroy()
  }

  _applyHeight(editor) {
    const rows = parseInt(this.element.getAttribute("rows") || "0")
    if (!rows) return
    const height = `${rows * 22}px`
    editor.editing.view.change(writer => {
      const root = editor.editing.view.document.getRoot()
      writer.setStyle("min-height", height, root)
      writer.setStyle("max-height", height, root)
      writer.setStyle("overflow-y", "auto", root)
    })
  }

  toolbarConfig() {
    if (this.toolbarValue === "mini") {
      return [
        "bold", "italic", "underline", "|",
        "numberedList", "bulletedList", "indent", "outdent", "|",
        "fontColor", "fontBackgroundColor"
      ]
    }
    if (this.toolbarValue === "documento") {
      return [
        "bold", "italic", "underline", "|",
        "fontSize", "|",
        "alignment:left", "alignment:center", "alignment:right", "alignment:justify", "|",
        "undo", "redo"
      ]
    }
    return [
      "bold", "italic", "underline", "|",
      "undo", "redo"
    ]
  }
}
